import React, {useRef, useState} from 'react';

import root from 'react-shadow/emotion';


import { useTheme, Container, Paper, ThemeProvider, createTheme} from '@mui/material';

import {jssPreset, StylesProvider} from '@mui/styles'

import { useAsync, useMeasure } from 'react-use';

import jssIncreaseSpecificity from 'jss-increase-specificity';
import { create } from 'jss';
import { BSSStyleProvider } from '../contexts/BSSStyleContext'
import {bssMakeStyles}  from '../lib/theming';
import { BSSDataProvider } from '../contexts/BSSDataContext';
import useBSSLogger from '../hooks/useBSSLogger';
import { AccediORegistrati } from './preventivo/FormPagamenti';
import * as locales from '@mui/material/locale';

// import { library, dom } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'
import DefaultLoadingComponent from './form/DefaultLoadingComponent';
// library.add(fas)
// library.add(fab) 


const {logger} = useBSSLogger();


const jss = create({
    plugins: [
        ...jssPreset().plugins, 
        jssIncreaseSpecificity({ repeat: 1 }), 
        //expand()
    ],
});

const nomeplugin = spedizioniweb2.nomeplugin;

const WrappedChild = ({children, paperProps = null, containerProps = null}) => {
    const [ref, {width}] = useMeasure();
    const tema = useTheme();
    const classes = bssMakeStyles();
    
    return (
        <BSSStyleProvider value={{mainContainerWidth: width, theme:tema}}>

                <Container maxWidth="xl" className={classes.container} style={{marginBottom: "0.5em"}} {...containerProps} ref={ref}>             
                    {/* <pre>{JSON.stringify(containerProps, null, 2)}</pre> */}
                    {[null, undefined].includes(paperProps) ? (children) : (
                        <Paper {...paperProps}>                            
                            {children}
                        </Paper>
                    )}                                                            
                </Container>
        </BSSStyleProvider>
    )
}

const Wrapper = ({
    children, 
    theme = createTheme((BSSComps_spedizioniweb2_theme !== undefined) ? BSSComps_spedizioniweb2_theme : {}, locales.itIT), 
    paperProps = null, 
    containerProps = null,
    shadowProps = null,
    inAdmin = false,
    inPortal = false,
    adminCustomizations = null
}) => {

    logger.debug("wrapper locale", locales.itIT)

    if(inPortal){
        paperProps = {
            ...paperProps,
        }
    }

    
    let Comp = (theme !== null && theme !== undefined) ? 
        (
            <ThemeProvider theme={theme}>
                <WrappedChild paperProps={paperProps} containerProps={containerProps}>
                    {children}
                </WrappedChild>
            </ThemeProvider>
        ) :
        (
            <WrappedChild paperProps={paperProps} containerProps={containerProps}>
                {children}
            </WrappedChild>
        );
    
    if(inPortal){
        logger.debug("creo shadow dom passando", shadowProps);
        Comp = <WrappedJssComponent inPortal shadowProps={shadowProps}>{Comp}</WrappedJssComponent>
    }

    return Comp;
}

/**
 * isolo lo stile seguendo la risposta:
 * https://stackoverflow.com/questions/51832583/react-components-material-ui-theme-not-scoped-locally-to-shadow-dom
 * 
 * @param {*} param0 
 * @returns 
 */
const WrappedJssComponent = ({children, inPortal = false, shadowProps = {}}) => {
    const [jss, setJss] = useState(null);
    const [idWrapper, setidWrapper] = useState(null);
    const shadowRootRef = useRef(null);

    let shadowBodyRef;

    const {body = {}} = (shadowProps ?? {});
    
    function setRefAndCreateJss(headRef) {
        if (headRef && !jss) {
            
            const createdJssWithRef = create({
                ...jssPreset(), 
                insertionPoint: headRef,
                plugins: [
                    ...jssPreset().plugins, 
                    jssIncreaseSpecificity({ repeat: 1 }), 
                ]
            })

            const wrapper = getClosest(shadowRootRef.current)
            let id = "spedizioniweb2_wrapper";

            if(wrapper?.id){
                const [idwrapper, _] = wrapper.id.split("_").reverse()
                logger.debug(`wrapper shadow dom`, wrapper.id, idwrapper);
                id = idwrapper;
            }    
            setJss(createdJssWithRef)
            setidWrapper(id)
            
            
        }
    }

    const shadowBody = shadowRootRef?.current?.shadowRoot?.querySelector(".shadow-body") ?? false


    const setBodyRef = (bodyRef) => {
        if(bodyRef){
            shadowBodyRef = bodyRef;
            logger.debug("differenza tra shadowbody e shadowbodyref", shadowBody, shadowBodyRef);

        }
    }
    
    return (
        <root.div ref={shadowRootRef}>
            <head className="shadow-head">
                <style ref={setRefAndCreateJss}></style>
                {/* <style>{dom.css()}</style> */}
                
                {/* <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
                    integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
                    crossOrigin=""
                /> */}

            </head>
            
            <body className='shadow-body' ref={setBodyRef} id={`spedizioniweb2_shadow_body_${idWrapper}`} {...body}>                
                {jss &&
                    <StylesProvider jss={jss}>                        
                        {typeof children === "function" ? children(idWrapper, shadowRootRef, shadowBody) : children}
                    </StylesProvider>
                }
            </body>            
            
        </root.div>
    )
}
/**
 * 
 * @param {{
 *     theme: import('@mui/material').Theme
 * }} param0 
 * @returns 
 */
const RootWrapper = ({children, theme = {}, paperProps = null}) => {

    theme = createTheme(theme, locales.itIT)

    
    const pattern = new RegExp(`^(BSSComps_${nomeplugin}|${nomeplugin}).*`) ;
    const data = Object.keys(window)
        .reduce((obj, k) => pattern.test(k) ? 
            {...obj, ...window[k]} 
            : obj
        , {});


    return (
        <>
            <WrappedJssComponent>
                {(idWrapper, shadowRootRef, shadowBody) => (
                    <>
                        <ThemeProvider theme={theme}>
                            
                            <WaitKCGuest>
                                <BSSDataProvider value={{...data, idWrapper, shadowRootRef, shadowBody}}>    
                                    <Wrapper theme={theme} paperProps={paperProps}>                          
                                        {children}                                                       
                                    </Wrapper>
                                </BSSDataProvider>
                            </WaitKCGuest>    
                        </ThemeProvider>
                    </>
                )}
                
            </WrappedJssComponent>
                
            
        </>
    )
    
}

/**
 * Se l'utente è loggato devo aspettare che keycloak sia inizializzato altrimenti partono richieste ajax senza l'header Authorization
 * Se l'utente non è loggato mostra il component figlio
 * 
 * @param {*} param0 
 * @returns 
 */
const WaitKCGuest =  ({LoadingComponent = DefaultLoadingComponent, state = null, children}) => {
    
    if(state === null){ 
        state = useAsync(async () => { 

            return await spedizioniweb2.kcChecker;
            
        })
    }
    

    return (
        <>
            {state.loading ? (
                <>
                    <LoadingComponent />
                </>
            ) : (
                <>
                    {children}
                </>
            )}                       
        </>
    );
}

/**
 * Da usare per le pagine che richiedono il login.
 * Se l'utente non è loggato mostra il componente NotLoggedIn (in genere un pulsante che rimanda al login/registrazione)
 * Se l'utente è loggato finchè keycloak non è inizializzato mostra il componente di caricamento 
 * 
 * @param {*} param0 
 * @returns 
 */
const WaitKC = ({LoadingComponent = DefaultLoadingComponent, NotLoggedInComponent = AccediORegistrati, children}) => {

    const state = useAsync(async () => {
        return await spedizioniweb2.kcChecker;
    })

    logger.debug("waitkc", state);

    return (!state.loading && !state.value.loggato) ? 
        (<NotLoggedInComponent />) : 
        (<WaitKCGuest {...{state, LoadingComponent, children}} />)
    ;
}

const getClosest = function (elem, selector=".spedizioniweb2_section_shortcode") {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if (typeof elem.matches === 'function' && elem.matches( selector ) ) return elem;
    }
    return null;

};

export default Wrapper;
export {
    RootWrapper,
    WrappedChild,
    Wrapper,
    WaitKC,
    WaitKCGuest,
    getClosest,
    WrappedJssComponent
}

